import React from 'react';
import { levels, semesterWeeks } from '../data/semester';

/** The full 16-week semester plan as a 4×4 grid with level-track dots. */
export function SemesterGrid() {
  return <div className="rounded-2xl border border-gold/40 bg-card p-3 shadow-card-dark sm:p-6" data-id="element-188" data-mp="25uv9ewftqm8o">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-189" data-mp="21t9ruxschjs5">
        <p className="font-display text-2xl font-extrabold leading-none text-white sm:text-3xl" data-id="element-190" data-mp="21vnk6yvn4hw0">
          Plan semestru · <span className="text-gold" data-id="element-191" data-mp="194m32s8e0c9u">16 tygodni</span>
        </p>
        <ul className="flex flex-wrap gap-x-4 gap-y-1.5" aria-label="Legenda poziomów" data-id="element-192" data-mp="196gnm5fqy2de">
          {levels.map(level => <li key={level.key} className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-copy-light sm:text-[11px]" data-id="element-193" data-mp="1i5afjii4u4km">
              <span className={`h-2 w-2 rounded-full ${level.dotClass}`} aria-hidden="true" data-id="element-194" data-mp="2yi8zcal3uhja" />
              {level.label}
            </li>)}
        </ul>
      </div>
      <ol className="mt-4 grid grid-cols-4 gap-1.5 sm:mt-5 sm:gap-2.5" data-id="element-195" data-mp="33osia7tt266m">
        {semesterWeeks.map((topic, index) => <li key={topic} className="flex min-h-[4.75rem] flex-col rounded-lg border border-white/10 bg-ink p-1.5 sm:min-h-[6.5rem] sm:p-3" data-id="element-196" data-mp="37ojdqoua1ahh" data-mpi={index}>
            <span className="text-[8px] font-bold uppercase tracking-[0.04em] text-gold sm:text-[10px] sm:tracking-[0.12em]" data-id="element-197" data-mp="3cn4gaux04693">
              Tydzień {index + 1}
            </span>
            <span className="mt-1 line-clamp-3 text-[10px] font-medium leading-tight text-white sm:mt-1.5 sm:text-sm sm:leading-snug" data-id="element-198" data-mp="2k233ngmj9x57">
              {topic}
            </span>
            <span className="mt-auto flex gap-1 pt-1.5" aria-hidden="true" data-id="element-199" data-mp="2txo06z8u257k">
              {levels.map(level => <span key={level.key} className={`h-1.5 w-1.5 rounded-full sm:h-2 sm:w-2 ${level.dotClass}`} data-id="element-200" data-mp="2yqh5bo87rfk6" />)}
            </span>
          </li>)}
      </ol>
    </div>;
}